import { normalizeString } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_MEMBERSHIP_CONTACT_EMAIL = createFcmConfig('membership_contact_email', {
	normalizer: normalizeString,
	defaultValue: 'help@change.org',
});
